import type { SingletonBalancePosting } from '@festina/life-general-types/life'

/**
 * Create a mirror of a `SingletonBalancePosting` (sender ↔ receiver),
 * except for its `accountType`, which is the only thing allowed to differ.
 * */
export const senderToReceiver = (
  { accountType: _, amount, ...rest }: SingletonBalancePosting,
  accountType: SingletonBalancePosting['accountType'],
): SingletonBalancePosting => ({
  ...rest,
  amount: amount ? -amount : undefined,
  accountType,
})
